module.exports = __webpack_public_path__ + "static/media/griffith_light.ee78e7a2.png";